import { createResource } from 'react-resource-router';
import { getMyTeamsEndpoint } from '../../endpoints/my-teams';
export const createMyTeamsResource = (checkConsolidationOnRouteDependency, depends) => createResource({
  type: 'myTeamsResource',
  getKey: () => 'myTeamsResource',
  getData: async ({
    dependencies
  }) => {
    const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
    if (!isConsolidated) {
      return null;
    }
    return getMyTeamsEndpoint();
  },
  isBrowserOnly: true,
  depends
});